/*eslint-disable*/
export const getFilteredGroups = (state) => state.groups.filteredGroups
